import Brand from "../Brand";

describe("Brand model", () => {
  test("hasMany relations", () => {
    expect(Brand.hasMany.map(relation => relation.name)).toMatchSnapshot();
  });
});
